"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseISOTimeSafe = exports.formatISOTime = exports.parseISOTime = exports.parseISOSafe = void 0;
const date_fns_1 = require("date-fns");
function parseISOSafe(date) {
    if (date == null) {
        return date;
    }
    else {
        return date_fns_1.parseISO(date);
    }
}
exports.parseISOSafe = parseISOSafe;
function parseISOTime(time) {
    const now = new Date();
    const dateTime = date_fns_1.formatISO(now, { representation: 'date' }) + 'T' + time;
    return date_fns_1.parseISO(dateTime);
}
exports.parseISOTime = parseISOTime;
function formatISOTime(date) {
    const time = date_fns_1.formatISO(date, { representation: 'time' });
    if (time.endsWith('Z')) {
        return time.slice(0, -1);
    }
    else if (time.includes('+')) {
        return time.slice(0, time.indexOf('+'));
    }
    else {
        return time;
    }
}
exports.formatISOTime = formatISOTime;
function parseISOTimeSafe(date) {
    if (date == null) {
        return date;
    }
    else {
        return parseISOTime(date);
    }
}
exports.parseISOTimeSafe = parseISOTimeSafe;
//# sourceMappingURL=date-utils.js.map